import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "title-icon"
};
const _hoisted_2 = {
  class: "text"
};
const _hoisted_3 = {
  key: 1,
  class: "new-tab"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_tab = _resolveComponent("b-tab");
  const _component_b_tabs = _resolveComponent("b-tabs");
  return _openBlock(), _createBlock(_component_b_tabs, {
    style: _normalizeStyle($options.cssProps),
    class: "navigation-tabs",
    modelValue: $options.currentTab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.currentTab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, tab => {
      return _openBlock(), _createBlock(_component_b_tab, {
        disabled: tab.disabled,
        key: tab.text,
        "title-link-class": [{
          separator: Boolean(tab.separator)
        }]
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [tab.icon ? (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), {
          key: 0,
          class: "icon",
          width: "16",
          height: "16"
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_2, _toDisplayString(tab.text), 1), tab.isNewTab ? (_openBlock(), _createElementBlock("div", _hoisted_3, "New")) : _createCommentVNode("", true)])]),
        _: 2
      }, 1032, ["disabled", "title-link-class"]);
    }), 128))]),
    _: 1
  }, 8, ["style", "modelValue"]);
}